module.exports = __webpack_public_path__ + "img/14.89c42951.jpg";